var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 687,
    height: 501,
    viewBox: "0 0 687 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2850_2613)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.36 332.465L159.676 335.149L162.36 337.832L165.043 335.149L162.36 332.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.359 316.684L159.676 319.367L162.359 322.051L165.043 319.367L162.359 316.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.352 300.864L159.668 303.547L162.352 306.231L165.035 303.547L162.352 300.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.352 285.098L159.669 287.781L162.352 290.465L165.036 287.781L162.352 285.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.352 269.309L159.668 271.992L162.352 274.676L165.035 271.992L162.352 269.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.353 348.207L159.67 350.891L162.353 353.574L165.037 350.891L162.353 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.773 332.418L182.089 335.102L184.773 337.785L187.456 335.102L184.773 332.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.771 316.637L182.088 319.321L184.771 322.004L187.455 319.321L184.771 316.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.763 300.817L182.079 303.5L184.763 306.184L187.446 303.5L184.763 300.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.764 285.051L182.08 287.734L184.764 290.418L187.447 287.734L184.764 285.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.762 269.262L182.078 271.945L184.762 274.629L187.445 271.945L184.762 269.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.775 348.207L182.091 350.891L184.775 353.574L187.458 350.891L184.775 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.194 332.426L204.511 335.109L207.194 337.793L209.878 335.109L207.194 332.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.193 316.715L204.51 319.399L207.193 322.082L209.877 319.398L207.193 316.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.184 300.895L204.5 303.578L207.184 306.262L209.867 303.578L207.184 300.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.185 285.121L204.501 287.805L207.185 290.488L209.868 287.805L207.185 285.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.183 269.348L204.499 272.031L207.183 274.715L209.866 272.031L207.183 269.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.194 348.207L204.511 350.891L207.194 353.574L209.878 350.891L207.194 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.615 332.426L226.932 335.11L229.615 337.793L232.299 335.11L229.615 332.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.614 316.645L226.931 319.328L229.614 322.012L232.298 319.328L229.614 316.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.603 300.825L226.92 303.508L229.603 306.192L232.287 303.508L229.603 300.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.604 285.051L226.921 287.734L229.604 290.418L232.288 287.734L229.604 285.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.602 269.27L226.919 271.953L229.602 274.637L232.286 271.953L229.602 269.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.615 348.2L226.932 350.883L229.615 353.567L232.299 350.883L229.615 348.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.044 332.465L249.36 335.149L252.044 337.832L254.727 335.149L252.044 332.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.043 316.684L249.359 319.367L252.043 322.051L254.726 319.367L252.043 316.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.032 300.864L249.349 303.547L252.032 306.231L254.716 303.547L252.032 300.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.034 285.098L249.351 287.781L252.034 290.465L254.718 287.781L252.034 285.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.032 269.309L249.349 271.992L252.032 274.676L254.716 271.992L252.032 269.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.035 348.2L249.352 350.883L252.035 353.567L254.719 350.883L252.035 348.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.467 332.473L271.783 335.156L274.467 337.84L277.15 335.157L274.467 332.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.466 316.684L271.782 319.367L274.466 322.051L277.149 319.367L274.466 316.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.454 300.864L271.771 303.547L274.454 306.231L277.138 303.547L274.454 300.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.456 285.098L271.772 287.781L274.456 290.465L277.14 287.781L274.456 285.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.454 269.309L271.771 271.992L274.454 274.676L277.138 271.992L274.454 269.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.456 348.207L271.773 350.891L274.457 353.574L277.14 350.891L274.456 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.884 332.457L294.201 335.141L296.884 337.824L299.568 335.141L296.884 332.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.883 316.676L294.199 319.36L296.883 322.043L299.566 319.36L296.883 316.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.871 300.856L294.187 303.539L296.871 306.223L299.554 303.539L296.871 300.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.872 285.082L294.189 287.766L296.872 290.449L299.556 287.766L296.872 285.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.871 269.309L294.187 271.992L296.871 274.676L299.554 271.992L296.871 269.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.874 348.2L294.19 350.883L296.874 353.567L299.558 350.883L296.874 348.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.308 332.473L316.624 335.156L319.308 337.84L321.991 335.157L319.308 332.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.306 316.684L316.622 319.367L319.306 322.051L321.989 319.367L319.306 316.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.293 300.864L316.609 303.547L319.293 306.231L321.976 303.547L319.293 300.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.295 285.098L316.611 287.781L319.295 290.465L321.978 287.781L319.295 285.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.293 269.309L316.609 271.992L319.293 274.676L321.976 271.992L319.293 269.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.296 348.207L316.612 350.891L319.296 353.574L321.979 350.891L319.296 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.73 332.473L339.046 335.156L341.73 337.84L344.413 335.157L341.73 332.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.728 316.692L339.045 319.375L341.728 322.059L344.412 319.375L341.728 316.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.715 300.864L339.031 303.547L341.715 306.231L344.398 303.547L341.715 300.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.717 285.098L339.033 287.781L341.717 290.465L344.4 287.781L341.717 285.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.715 269.309L339.031 271.992L341.715 274.676L344.398 271.992L341.715 269.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.718 348.207L339.034 350.891L341.718 353.574L344.401 350.891L341.718 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.994 332.402L137.31 335.086L139.994 337.77L142.678 335.086L139.994 332.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.94 316.692L137.257 319.375L139.94 322.059L142.624 319.375L139.94 316.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.934 300.871L137.25 303.555L139.934 306.238L142.617 303.555L139.934 300.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.935 285.098L137.251 287.781L139.935 290.465L142.618 287.781L139.935 285.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.934 269.317L137.25 272L139.934 274.684L142.617 272L139.934 269.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.935 348.207L137.251 350.891L139.935 353.574L142.618 350.891L139.935 348.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.151 332.473L361.468 335.156L364.151 337.84L366.835 335.156L364.151 332.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.15 316.762L361.466 319.445L364.15 322.129L366.833 319.445L364.15 316.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.135 300.934L361.452 303.617L364.135 306.301L366.819 303.617L364.135 300.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.138 285.168L361.454 287.852L364.138 290.535L366.821 287.852L364.138 285.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.136 269.387L361.452 272.07L364.136 274.754L366.819 272.07L364.136 269.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.137 348.207L361.453 350.891L364.137 353.574L366.82 350.891L364.137 348.207Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0587 207.077L88.4717 209.664L91.0587 212.251L93.6457 209.664L91.0587 207.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8546 207.062L73.2676 209.649L75.8546 212.236L78.4416 209.649L75.8546 207.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6466 207.062L58.0596 209.649L60.6466 212.236L63.2336 209.649L60.6466 207.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4396 207.062L42.8525 209.649L45.4396 212.236L48.0266 209.649L45.4396 207.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2182 207.085L27.6309 209.672L30.2175 212.259L32.8049 209.673L30.2182 207.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.271 207.062L103.684 209.649L106.271 212.236L108.858 209.649L106.271 207.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0548 185.468L88.4678 188.055L91.0548 190.642L93.6418 188.055L91.0548 185.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8502 185.46L73.2632 188.047L75.8502 190.634L78.4372 188.047L75.8502 185.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6417 185.46L58.0547 188.047L60.6417 190.634L63.2287 188.047L60.6417 185.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4337 185.46L42.8467 188.047L45.4337 190.634L48.0207 188.047L45.4337 185.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2311 185.452L27.644 188.039L30.2311 190.626L32.8181 188.039L30.2311 185.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.267 185.46L103.68 188.047L106.267 190.634L108.854 188.047L106.267 185.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0558 163.85L88.4688 166.438L91.0558 169.025L93.6428 166.438L91.0558 163.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8507 163.843L73.2637 166.43L75.8507 169.017L78.4377 166.43L75.8507 163.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6417 163.843L58.0547 166.43L60.6417 169.017L63.2287 166.43L60.6417 163.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4342 163.843L42.8472 166.43L45.4342 169.017L48.0212 166.43L45.4342 163.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2306 163.835L27.6436 166.422L30.2306 169.009L32.8176 166.422L30.2306 163.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27 163.835L103.683 166.422L106.27 169.009L108.857 166.422L106.27 163.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0572 142.233L88.4702 144.82L91.0572 147.407L93.6443 144.82L91.0572 142.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8507 142.225L73.2637 144.812L75.8507 147.399L78.4377 144.812L75.8507 142.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6427 142.225L58.0557 144.812L60.6427 147.399L63.2297 144.812L60.6427 142.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4347 142.225L42.8477 144.812L45.4347 147.399L48.0217 144.812L45.4347 142.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2306 142.217L27.6436 144.804L30.2306 147.391L32.8176 144.804L30.2306 142.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27 142.217L103.683 144.804L106.27 147.391L108.857 144.804L106.27 142.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0577 120.624L88.4707 123.211L91.0577 125.798L93.6448 123.211L91.0577 120.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8507 120.616L73.2637 123.203L75.8507 125.79L78.4377 123.203L75.8507 120.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6427 120.616L58.0557 123.203L60.6427 125.79L63.2297 123.203L60.6427 120.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4347 120.616L42.8477 123.203L45.4347 125.79L48.0217 123.203L45.4347 120.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2296 120.608L27.6426 123.195L30.2296 125.782L32.8166 123.195L30.2296 120.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.269 120.608L103.682 123.195L106.269 125.782L108.856 123.195L106.269 120.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0587 99.0067L88.4717 101.594L91.0587 104.181L93.6457 101.594L91.0587 99.0067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8507 98.9989L73.2637 101.586L75.8507 104.173L78.4377 101.586L75.8507 98.9989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6422 98.9989L58.0552 101.586L60.6422 104.173L63.2292 101.586L60.6422 98.9989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4347 98.9989L42.8477 101.586L45.4347 104.173L48.0217 101.586L45.4347 98.9989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2286 98.9911L27.6416 101.578L30.2286 104.165L32.8157 101.578L30.2286 98.9911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.268 98.9911L103.681 101.578L106.268 104.165L108.855 101.578L106.268 98.9911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0587 77.3895L88.4717 79.9766L91.0587 82.5636L93.6457 79.9766L91.0587 77.3895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8507 77.3817L73.2637 79.9688L75.8507 82.5558L78.4377 79.9687L75.8507 77.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6422 77.3817L58.0552 79.9688L60.6422 82.5558L63.2292 79.9688L60.6422 77.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4337 77.3817L42.8467 79.9688L45.4337 82.5558L48.0207 79.9687L45.4337 77.3817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2276 77.3739L27.6406 79.9609L30.2276 82.548L32.8147 79.9609L30.2276 77.3739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.267 77.3739L103.68 79.9609L106.267 82.548L108.854 79.9609L106.267 77.3739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0597 55.7721L88.4727 58.3591L91.0597 60.9462L93.6467 58.3591L91.0597 55.7721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8507 55.7643L73.2637 58.3513L75.8507 60.9383L78.4377 58.3513L75.8507 55.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6427 55.7643L58.0557 58.3513L60.6427 60.9383L63.2297 58.3513L60.6427 55.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4347 55.7643L42.8477 58.3513L45.4347 60.9383L48.0217 58.3513L45.4347 55.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2241 55.7725L27.6367 58.3591L30.2234 60.9465L32.8108 58.3599L30.2241 55.7725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.267 55.7643L103.68 58.3513L106.267 60.9383L108.854 58.3513L106.267 55.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0587 34.1552L88.4717 36.7422L91.0587 39.3292L93.6457 36.7422L91.0587 34.1552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8502 34.1473L73.2632 36.7344L75.8502 39.3214L78.4372 36.7344L75.8502 34.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6422 34.1474L58.0552 36.7344L60.6422 39.3214L63.2292 36.7344L60.6422 34.1474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.439 34.1552L42.8516 36.7422L45.4386 39.3296L48.026 36.7425L45.439 34.1552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2251 34.1555L27.6377 36.7422L30.2244 39.3296L32.8117 36.7429L30.2251 34.1555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.266 34.1474L103.679 36.7344L106.266 39.3214L108.853 36.7344L106.266 34.1474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0582 228.687L88.4712 231.274L91.0582 233.861L93.6452 231.274L91.0582 228.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8556 228.671L73.2686 231.258L75.8556 233.845L78.4426 231.258L75.8556 228.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6471 228.671L58.0601 231.258L60.6471 233.845L63.2341 231.258L60.6471 228.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4405 228.671L42.8535 231.258L45.4405 233.845L48.0276 231.258L45.4405 228.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2173 228.695L27.6299 231.281L30.2165 233.869L32.8039 231.282L30.2173 228.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.272 228.671L103.685 231.258L106.272 233.845L108.859 231.258L106.272 228.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0597 12.5458L88.4727 15.1328L91.0597 17.7198L93.6467 15.1328L91.0597 12.5458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8502 12.538L73.2632 15.125L75.8502 17.712L78.4372 15.125L75.8502 12.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6422 12.538L58.0552 15.125L60.6422 17.712L63.2292 15.125L60.6422 12.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4337 12.538L42.8467 15.125L45.4337 17.712L48.0207 15.125L45.4337 12.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2261 12.5462L27.6387 15.1328L30.2253 17.7202L32.8127 15.1335L30.2261 12.5462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.266 12.538L103.679 15.125L106.266 17.712L108.853 15.125L106.266 12.538Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M351.992 488.311C510.624 488.311 639.22 484.99 639.22 480.894C639.22 476.797 510.624 473.477 351.992 473.477C193.361 473.477 64.7642 476.797 64.7642 480.894C64.7642 484.99 193.361 488.311 351.992 488.311Z",
    fill: "#43457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.984 163.472H511.362C510.031 163.472 508.875 162.601 508.454 161.337C508.138 160.386 507.753 159.465 507.306 158.581C506.711 157.403 506.907 155.981 507.84 155.047L511.336 151.55C512.419 150.469 512.419 148.714 511.336 147.633L509.336 145.632C508.141 144.437 506.203 144.437 505.007 145.632L501.714 148.925C500.781 149.858 499.36 150.053 498.182 149.458C497.298 149.011 496.378 148.627 495.426 148.31C494.163 147.889 493.291 146.734 493.291 145.402V140.78C493.291 139.089 491.92 137.719 490.23 137.719H487.691C486 137.719 484.63 139.089 484.63 140.78V145.402C484.63 146.734 483.758 147.889 482.495 148.31C481.543 148.626 480.623 149.011 479.739 149.458C478.561 150.053 477.14 149.858 476.207 148.925L472.914 145.632C471.719 144.437 469.78 144.437 468.585 145.632L466.585 147.633C465.503 148.714 465.503 150.469 466.585 151.55L470.082 155.048C471.015 155.981 471.211 157.403 470.616 158.581C470.169 159.465 469.784 160.385 469.467 161.336C469.047 162.6 467.892 163.471 466.559 163.471H461.937C460.247 163.471 458.876 164.842 458.876 166.533V169.071C458.876 170.762 460.247 172.133 461.937 172.133H466.559C467.891 172.133 469.047 173.004 469.467 174.268C469.784 175.219 470.169 176.14 470.616 177.023C471.211 178.201 471.015 179.623 470.082 180.556L466.585 184.054C465.503 185.135 465.503 186.89 466.585 187.971L468.585 189.972C469.78 191.167 471.719 191.167 472.914 189.972L476.205 186.68C477.139 185.747 478.561 185.552 479.739 186.147C480.623 186.594 481.544 186.979 482.495 187.296C483.758 187.716 484.629 188.872 484.629 190.203V194.824C484.629 196.515 486 197.886 487.691 197.886H490.229C491.92 197.886 493.291 196.515 493.291 194.824V190.203C493.291 188.871 494.162 187.715 495.425 187.295C496.377 186.978 497.298 186.593 498.182 186.146C499.36 185.551 500.78 185.747 501.713 186.68L505.007 189.973C506.202 191.168 508.141 191.168 509.336 189.972L511.336 187.972C512.418 186.891 512.418 185.136 511.336 184.054L507.839 180.557C506.906 179.624 506.71 178.202 507.306 177.023C507.752 176.139 508.137 175.218 508.454 174.267C508.875 173.004 510.03 172.133 511.362 172.133H515.983C517.674 172.133 519.045 170.762 519.045 169.071V166.533C519.045 164.842 517.675 163.472 515.984 163.472ZM499.571 168.663C499.166 173.822 494.987 178.003 489.828 178.411C483.268 178.931 477.834 173.498 478.352 166.938C478.759 161.78 482.936 157.602 488.093 157.193C494.653 156.674 500.086 162.104 499.571 168.663Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.493 434.442C176.123 437.447 179.635 435.343 179.635 435.343C179.635 435.343 179.433 434.354 177.857 433.526C176.681 432.908 174.991 433.419 174.393 433.635L172.455 433.584L172.426 433.585C171.994 433.606 171.567 433.64 171.141 433.681C176.667 431.729 174.062 425.203 174.062 425.203C174.062 425.203 172.328 425.274 170.489 427.724C169.014 429.689 169.594 433.025 169.765 433.844C167.56 434.16 165.431 434.719 163.398 435.453C163.66 435.2 163.93 434.914 164.203 434.587C166.309 432.065 165.38 427.28 165.38 427.28C157.836 428.249 159.338 435.344 159.786 436.973C157.321 438.159 155.034 439.562 152.967 441.03C153.498 440.297 154.053 439.243 154.455 437.747C155.408 434.195 152.213 429.774 152.213 429.774C144.818 434.427 150.138 441.15 151.182 442.352C149.855 443.376 148.636 444.408 147.541 445.4C146.339 446.489 145.231 447.575 144.223 448.619C144.592 447.63 144.902 446.066 144.604 443.824C144.074 439.838 138.992 436.717 138.992 436.717C133.605 444.345 141.313 448.867 143.119 449.789C139.693 453.503 137.714 456.419 137.687 456.458L138.354 456.908C138.376 456.876 139.671 454.968 141.974 452.284C144.83 461.327 154.657 456.73 154.657 456.73C154.657 456.73 154.413 454.263 150.77 451.844C148.422 450.285 144.923 450.69 143.04 451.071C144.452 449.498 146.15 447.744 148.096 445.983C148.736 445.403 149.421 444.809 150.143 444.212C152.673 452.744 161.802 448.476 161.802 448.476C161.802 448.476 161.579 446.22 158.247 444.008C156.152 442.617 153.055 442.935 151.305 443.275C153.416 441.619 155.817 439.973 158.453 438.555C160.015 446.622 168.602 443.37 168.602 443.37C168.602 443.37 168.555 441.344 165.736 439.149C163.892 437.713 160.958 437.852 159.416 438.052C162.265 436.612 165.366 435.456 168.65 434.842C168.513 442.159 176.438 440.744 176.438 440.744C176.438 440.744 176.718 439.031 174.69 436.736C173.111 434.95 169.88 434.798 168.924 434.793C170.078 434.588 171.254 434.448 172.45 434.389L174.493 434.442Z",
    fill: "url(#paint0_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.485 477.942C110.485 477.942 94.0385 440.816 105.938 406.319C117.839 371.822 146.574 361.742 146.574 361.742C146.574 361.742 129.517 381.492 139.418 412.297C148.782 441.432 130.926 477.942 130.926 477.942H110.485V477.942Z",
    fill: "url(#paint1_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.302 477.94C116.302 477.94 112.09 402.412 129.91 382.547C113.7 407.587 120.451 477.94 120.451 477.94H116.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.553 477.938H126.963C127.663 474.839 130.195 465.475 136.508 458.412C144.179 449.831 153.855 450.663 153.855 450.663C153.855 450.663 148.592 456.437 147.784 466.814C147.463 470.949 146.063 474.825 144.553 477.938Z",
    fill: "url(#paint2_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.878 436.875C116.684 453.57 119.556 475.341 119.86 477.939H94.9626C88.6633 472.124 80.9403 462.717 80.8801 451.403C80.7727 431.2 71.3975 419.219 71.3975 419.219C71.3975 419.219 90.2374 419.094 103.878 436.875Z",
    fill: "url(#paint3_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M132.666 477.945H131.348C133.852 472.21 140.24 458.771 146.222 456.039C140.372 459.962 134.989 472.119 132.666 477.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.993 477.94H109.407C106.376 467.915 97.1095 439.999 85.4141 430.781C97.4932 437.477 108.775 468.462 111.993 477.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5731 480.891H154.8V477.946H80.5731V480.891Z",
    fill: "#43457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.917 211.648H282.11C277.847 211.648 274.392 215.104 274.392 219.367V446.484C274.392 450.747 277.847 454.202 282.11 454.202H616.917C621.18 454.202 624.635 450.747 624.635 446.484V219.367C624.635 215.104 621.18 211.648 616.917 211.648Z",
    fill: "#363868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79 467.963C365.354 467.963 364.923 468.059 364.529 468.245L349.637 475.247C346.771 476.595 347.731 480.896 350.9 480.896H548.128C551.289 480.896 552.256 476.611 549.402 475.253L534.688 468.251C534.291 468.061 533.855 467.963 533.414 467.963H473.885V467.93H425.143V467.963H365.79Z",
    fill: "#363868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.138 420.027H281.889C280.673 420.027 279.688 419.041 279.688 417.825V220.006C279.688 218.79 280.673 217.805 281.889 217.805H617.138C618.354 217.805 619.34 218.79 619.34 220.006V417.825C619.34 419.041 618.354 420.027 617.138 420.027Z",
    fill: "url(#paint4_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.535 454.219H411.491V467.928H487.535V454.219Z",
    fill: "#43457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79 467.963C365.354 467.963 364.923 468.059 364.529 468.245L349.637 475.247C346.771 476.595 347.731 480.896 350.9 480.896H548.128C551.289 480.896 552.256 476.611 549.402 475.253L534.688 468.251C534.291 468.061 533.855 467.963 533.414 467.963H473.885V467.93H425.143V467.963H365.79Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.019 468.19L256.657 465.734L262.266 467.625L261.23 469.947L256.019 468.19Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.144 470.591C263.144 470.591 263.394 472.606 263.989 473.478C264.32 473.963 265.057 475.058 267.607 476.634C269.648 477.896 273.541 478.07 273.668 478.766C273.953 480.331 272.495 480.637 272.391 480.602C272.365 480.593 268.981 481.25 267.04 480.612C261.448 478.777 252.821 475.704 252.74 475.521C252.629 475.274 255.362 467.969 255.362 467.969L263.144 470.591Z",
    fill: "url(#paint5_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.319 276.358C322.428 275.798 322.701 275.133 323.241 275.096C323.816 275.056 324.161 275.802 324.089 276.405C324.068 276.584 324.025 276.774 324.09 276.94C324.258 277.366 324.869 277.215 325.239 276.96C325.869 276.526 326.436 275.99 326.915 275.378C327.283 274.906 327.6 274.388 328.014 273.961C328.429 273.535 328.97 273.198 329.546 273.211C330.655 273.236 331.362 274.503 331.497 275.662C331.716 277.536 331.008 279.452 329.867 280.926C329.216 281.765 328.397 282.502 327.416 282.82C326.955 282.97 326.468 283.023 326.013 283.193C325.314 283.454 324.73 283.973 324.071 284.332C323.907 284.422 323.425 285.229 323.243 285.21C323.087 285.194 322.738 284.99 322.605 284.903C322.035 284.528 320.788 283.625 320.374 283.067C319.53 281.93 321.117 281.162 321.578 280.02C322.044 278.863 322.084 277.574 322.319 276.358Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.698 265.178C223.883 264.639 223.977 263.926 223.527 263.624C223.049 263.303 222.378 263.779 222.14 264.337C222.07 264.503 222.012 264.689 221.872 264.8C221.515 265.085 221.06 264.65 220.866 264.245C220.537 263.555 220.311 262.808 220.202 262.038C220.118 261.446 220.101 260.839 219.954 260.262C219.808 259.686 219.506 259.123 219 258.848C218.026 258.318 216.783 259.064 216.088 260.001C214.964 261.517 214.623 263.531 214.879 265.377C215.024 266.429 215.367 267.477 216.059 268.241C216.385 268.6 216.78 268.889 217.09 269.263C217.566 269.837 217.814 270.578 218.207 271.219C218.304 271.378 218.319 272.318 218.487 272.392C218.63 272.456 219.034 272.453 219.192 272.443C219.874 272.402 221.405 272.24 222.042 271.963C223.34 271.398 222.347 269.942 222.516 268.723C222.688 267.487 223.296 266.349 223.698 265.178Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.399 294.328C259.698 295.734 260.231 297.087 261.004 298.299C261.257 298.697 261.498 299.11 261.749 299.665C262.064 300.362 262.062 302.827 262.817 302.95C263.327 303.033 263.313 301.085 263.65 300.693C263.987 300.301 264.173 299.804 264.33 299.312C265.108 296.868 265.402 294.098 267.198 292.267C268.191 291.253 269.597 290.679 271.009 290.635C272.537 290.587 273.838 291.695 275.302 291.607C278.085 291.439 281.174 289.151 282.369 286.71C283.281 284.848 283.376 282.571 282.486 280.699C281.594 278.827 279.69 277.438 277.621 277.306C277.146 277.276 276.652 277.312 276.23 277.532C275.889 277.71 275.619 277.994 275.342 278.261C274.064 279.493 272.513 280.439 270.834 281.015C268.751 281.728 266.52 281.864 264.365 282.319C263.122 282.582 261.829 282.999 261.01 283.971C259.975 285.201 259.36 288.01 259.207 289.956C258.998 291.676 259.062 292.745 259.399 294.328Z",
    fill: "#43457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.872 383.812L185.132 384.737L182.492 390.035L180.419 388.734L182.872 383.812Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.527 390.513C179.527 390.513 177.497 390.485 176.551 390.955C176.026 391.217 174.84 391.797 172.93 394.107C171.4 395.956 170.695 399.789 169.988 399.819C168.399 399.887 168.295 398.402 168.344 398.303C168.357 398.278 168.17 394.836 169.067 393.001C171.65 387.713 175.876 379.588 176.068 379.532C176.328 379.457 183.191 383.164 183.191 383.164L179.527 390.513Z",
    fill: "url(#paint6_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.296 390.553C283.378 386.544 266.113 362.993 266.113 362.993L238.813 358.325L232.903 357.404L225.954 354.523L218.025 388.469C217.991 388.856 217.86 389.207 217.671 389.516C217.192 390.3 216.295 390.785 215.319 390.672L213.878 390.39L185.153 384.765L182.214 390.262L217.933 410.684C222.269 411.834 225.837 409.316 228.909 405.858L247.171 384.581C247.779 383.851 248.316 383.361 248.816 383.088C249.91 382.49 250.824 382.932 251.912 384.169L261.579 394.693L266.433 399.977C267.044 400.813 267.632 401.218 267.497 402.073L256.222 465.845L262.512 468.155C262.512 468.155 294.255 409.271 285.296 390.553Z",
    fill: "url(#paint7_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M217.954 391.629C220.598 389.73 221.616 384.916 223.378 379.219C225.141 373.523 229.956 364.707 229.956 364.707L233.283 355.237L225.954 354.523L218.025 388.469C217.99 388.856 217.86 389.207 217.671 389.516C217.192 390.3 216.294 390.785 215.318 390.672L213.878 390.39C214.903 391.567 216.43 392.723 217.954 391.629Z",
    fill: "#221F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.628 305.15L270.437 312.552L261.754 309.517L263.074 298.117L272.078 300.794L272.628 305.15Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M264.025 300.008C264.025 300.008 264.785 305.821 266.701 306.8C268.617 307.779 271.837 306.881 271.837 306.881L272.628 305.149C272.628 305.149 270.582 305.995 269.243 305.609C267.904 305.222 268.05 305.286 267.904 305.222C267.758 305.159 267.758 305.159 267.758 305.159C267.758 305.159 265.374 304.397 264.025 300.008Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.478 290.428C279.144 288.396 278.228 287.781 276.891 287.596C275.646 287.424 274.037 287.625 272.997 287.41C271.901 287.183 270.818 287.103 269.701 287.023C267.788 286.886 266.951 288.655 266.628 289.844C266.623 289.864 266.617 289.885 266.612 289.906C266.317 291.048 265.985 293.767 265.524 294.643C265.055 295.535 264.391 291.258 262.787 290.848C262.434 290.758 262.102 290.694 261.695 290.798C260.93 290.993 260.32 291.677 260.179 292.49C259.988 293.589 260.454 294.689 261.077 295.576C261.699 296.462 262.484 297.213 263.075 298.123C264.257 299.941 264.616 302.314 266.047 303.92C267.654 305.724 270.416 306.129 272.628 305.155C274.84 304.181 276.479 302.004 277.188 299.602C278.082 296.575 277.499 293.413 278.478 290.428Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.79 288.665C274.365 288.546 276.278 287.847 276.89 287.596C275.646 287.424 274.036 287.625 272.997 287.41C271.901 287.183 270.818 287.103 269.701 287.023C267.788 286.886 266.95 288.655 266.628 289.844C266.623 289.864 266.617 289.885 266.612 289.906C267.415 288.999 269.278 288.782 271.79 288.665Z",
    fill: "#F8AC9B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M258.786 368.922C257.813 372.666 248.815 383.091 248.815 383.091C249.91 382.493 250.823 382.935 251.911 384.173L265.871 399.369C264.378 397.242 258.758 387.815 257.13 385.572C254.553 382.023 257.91 376.471 258.786 368.922Z",
    fill: "#221F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.634 306.64L290.436 303.157C293.041 302.544 295.479 301.367 297.579 299.709L320.295 281.77L324.714 285.45L302.514 310.204C301.118 311.759 299.467 313.065 297.63 314.062L278.568 324.417L267.439 353.904C267.357 354.123 267.281 354.343 267.212 354.566C266.779 355.962 266.801 357.459 267.17 358.873L268.261 363.048C268.102 365.169 264.219 364.192 262.104 363.976C251.494 363.317 241.511 359.019 229.63 359.629C226.967 359.273 225.245 356.628 225.996 354.048L236.707 317.265L229.029 310.795C225.822 308.092 223.651 304.361 222.885 300.238L217.479 271.151L222.922 270.492L230.36 291.515C232.165 296.617 236.153 300.646 241.236 302.503L246.879 304.564L261.755 307.002C261.755 307.002 267.185 313.497 270.294 310.863C271.015 310.253 271.874 307.701 271.874 307.701L275.634 306.64Z",
    fill: "url(#paint8_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M236.706 317.265L241.952 321.05L228.221 346.407L236.706 317.265Z",
    fill: "#221F1F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M270.897 310.011C270.897 310.011 270.716 312.56 267.48 312.986C264.243 313.412 257.183 306.25 257.183 306.25L261.754 306.999C261.754 306.999 265.401 311.408 268.542 311.487C269.358 311.479 270.359 311.164 270.897 310.011Z",
    fill: "#221F1F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.585 112.26L154.264 58.1254C148.186 56.9125 142.275 60.8569 141.063 66.9348L137.04 87.096L107.772 233.787C106.664 239.342 110.268 244.744 115.823 245.852L389.039 300.365C394.594 301.474 399.995 297.869 401.104 292.314L430.372 145.623L434.394 125.461C435.607 119.383 431.663 113.473 425.585 112.26Z",
    fill: "#808285"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M425.592 112.229L154.272 58.0941C148.193 56.8813 142.283 60.8256 141.07 66.9036L137.048 87.0648L107.779 233.756C106.671 239.311 110.276 244.712 115.831 245.821L389.046 300.334C394.602 301.442 400.003 297.837 401.111 292.282L430.379 145.591L434.402 125.43C435.615 119.352 431.671 113.442 425.592 112.229Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.998 103.424L149.677 49.2894C143.599 48.0766 137.689 52.021 136.476 58.0989L132.454 78.2601L103.186 224.951C102.077 230.506 105.682 235.908 111.237 237.016L384.452 291.529C390.008 292.637 395.409 289.033 396.517 283.478L425.785 136.786L429.808 116.625C431.021 110.547 427.076 104.637 420.998 103.424Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.244 236.975L384.46 291.488C390.015 292.596 395.417 288.991 396.525 283.436L425.793 136.745L132.461 78.2188L103.193 224.91C102.084 230.465 105.689 235.866 111.244 236.975Z",
    fill: "url(#paint9_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.006 103.385L149.685 49.2504C143.607 48.0375 137.697 51.9819 136.484 58.0598L132.461 78.221L425.793 136.747L429.816 116.586C431.029 110.508 427.084 104.598 421.006 103.385Z",
    fill: "url(#paint10_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.197 70.1379C155.865 70.1379 158.028 67.9752 158.028 65.3073C158.028 62.6393 155.865 60.4766 153.197 60.4766C150.529 60.4766 148.367 62.6393 148.367 65.3073C148.367 67.9752 150.529 70.1379 153.197 70.1379Z",
    fill: "url(#paint11_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.969 69.6519C174.447 72.2683 171.902 73.9662 169.286 73.4441C166.67 72.922 164.972 70.3778 165.494 67.7615C166.016 65.1451 168.56 63.4472 171.177 63.9693C173.793 64.4914 175.491 67.0356 174.969 69.6519Z",
    fill: "url(#paint12_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.265 76.9348C189.933 76.9348 192.096 74.772 192.096 72.1041C192.096 69.4362 189.933 67.2734 187.265 67.2734C184.597 67.2734 182.435 69.4362 182.435 72.1041C182.435 74.772 184.597 76.9348 187.265 76.9348Z",
    fill: "url(#paint13_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.798 143.918L284.626 117.344L283.89 121.034L417.062 147.608L417.798 143.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.059 141.42L282.473 128.133L281.737 131.823L348.322 145.11L349.059 141.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.906 152.209L280.32 138.922L279.584 142.612L346.17 155.899L346.906 152.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.981 248.231L263.81 221.656L263.073 225.346L396.245 251.921L396.981 248.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.242 245.732L261.657 232.445L260.92 236.135L327.506 249.422L328.242 245.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.089 256.521L259.504 243.234L258.768 246.924L325.353 260.211L326.089 256.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.689 214.613L270.517 188.039L269.781 191.729L402.952 218.303L403.689 214.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.95 212.115L268.364 198.828L267.628 202.518L334.213 215.805L334.95 212.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.797 222.904L266.211 209.617L265.475 213.307L332.061 226.594L332.797 222.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.743 179.262L277.572 152.687L276.835 156.377L410.007 182.952L410.743 179.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.004 176.771L275.419 163.484L274.683 167.174L341.268 180.461L342.004 176.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.852 187.561L273.266 174.273L272.53 177.963L339.115 191.251L339.852 187.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.111 97.4638L272.126 124.406L273.965 115.194L138.95 88.2511L137.111 97.4638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.584 132.169L135.568 105.227L113.094 217.851L248.109 244.793L270.584 132.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19 292.125H448.838C447.668 292.125 446.721 293.074 446.721 294.243V303.177C446.721 304.346 447.669 305.294 448.838 305.294H450.19C451.359 305.294 452.307 304.346 452.307 303.176V294.243C452.307 293.073 451.359 292.125 450.19 292.125Z",
    fill: "url(#paint14_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19 231.071H448.838C447.668 231.071 446.721 232.019 446.721 233.188V242.122C446.721 243.292 447.669 244.239 448.838 244.239H450.19C451.359 244.239 452.307 243.291 452.307 242.122V233.188C452.307 232.019 451.359 231.071 450.19 231.071Z",
    fill: "url(#paint15_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.571 268.86V267.508C425.571 266.339 424.623 265.391 423.454 265.391H414.52C413.351 265.391 412.403 266.339 412.403 267.508V268.86C412.403 270.03 413.351 270.977 414.52 270.977H423.454C424.623 270.977 425.571 270.029 425.571 268.86Z",
    fill: "url(#paint16_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.507 265.391H475.574C474.404 265.391 473.457 266.339 473.457 267.508V268.86C473.457 270.03 474.405 270.977 475.574 270.977H484.507C485.677 270.977 486.624 270.029 486.624 268.86V267.508C486.624 266.339 485.677 265.391 484.507 265.391Z",
    fill: "url(#paint17_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.019 289.199L436.852 288.517C435.842 287.927 434.545 288.267 433.956 289.277L429.449 296.99C428.859 298 429.199 299.297 430.209 299.887L431.376 300.569C432.386 301.159 433.682 300.819 434.272 299.809L438.779 292.095C439.369 291.086 439.029 289.789 438.019 289.199Z",
    fill: "url(#paint18_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.009 247.168L462.176 247.85C463.186 248.44 464.482 248.1 465.072 247.09L469.579 239.377C470.169 238.367 469.829 237.07 468.819 236.48L467.652 235.798C466.642 235.208 465.346 235.548 464.756 236.558L460.249 244.272C459.659 245.281 459.999 246.578 461.009 247.168Z",
    fill: "url(#paint19_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.89 252.942L425.604 257.449C426.614 258.039 427.91 257.698 428.5 256.689L429.182 255.521C429.772 254.512 429.432 253.215 428.422 252.625L420.709 248.118C419.699 247.528 418.402 247.868 417.813 248.878L417.13 250.046C416.54 251.055 416.881 252.352 417.89 252.942Z",
    fill: "url(#paint20_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.137 283.422L473.423 278.915C472.414 278.325 471.117 278.665 470.527 279.675L469.845 280.842C469.255 281.852 469.595 283.149 470.605 283.739L478.319 288.246C479.329 288.835 480.625 288.495 481.215 287.486L481.897 286.318C482.487 285.308 482.147 284.012 481.137 283.422Z",
    fill: "url(#paint21_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.245 280.947L428.557 279.783C427.962 278.776 426.664 278.443 425.658 279.038L417.966 283.582C416.96 284.178 416.626 285.476 417.221 286.482L417.908 287.646C418.503 288.653 419.802 288.987 420.809 288.392L428.5 283.847C429.506 283.252 429.84 281.953 429.245 280.947Z",
    fill: "url(#paint22_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.782 255.42L470.47 256.584C471.065 257.59 472.363 257.924 473.37 257.329L481.061 252.784C482.068 252.189 482.402 250.891 481.807 249.885L481.119 248.721C480.524 247.714 479.226 247.38 478.219 247.975L470.528 252.52C469.521 253.115 469.187 254.413 469.782 255.42Z",
    fill: "url(#paint23_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.851 247.168C434.446 248.175 435.744 248.508 436.751 247.914L437.915 247.226C438.921 246.631 439.255 245.333 438.66 244.326L434.115 236.635C433.52 235.628 432.222 235.294 431.216 235.889L430.052 236.577C429.045 237.172 428.711 238.47 429.306 239.477L433.851 247.168Z",
    fill: "url(#paint24_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.176 289.197C464.581 288.191 463.283 287.857 462.277 288.452L461.113 289.139C460.106 289.734 459.772 291.032 460.367 292.039L464.912 299.73C465.507 300.737 466.806 301.071 467.812 300.476L468.976 299.788C469.983 299.193 470.316 297.895 469.721 296.889L465.176 289.197Z",
    fill: "url(#paint25_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.502 337.555H403.903V341.904H462.502V337.555Z",
    fill: "url(#paint26_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.517 342.716H405.51C403.923 342.716 402.632 341.425 402.632 339.838V339.551C402.632 337.963 403.924 336.672 405.51 336.672H493.517C495.104 336.672 496.395 337.963 496.395 339.551V339.838C496.395 341.425 495.104 342.716 493.517 342.716ZM405.51 337.952C404.629 337.952 403.912 338.669 403.912 339.551V339.838C403.912 340.719 404.629 341.437 405.51 341.437H493.517C494.398 341.437 495.116 340.719 495.116 339.838V339.551C495.116 338.669 494.398 337.952 493.517 337.952H405.51Z",
    fill: "url(#paint27_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.601 329.313V319.06H424.843V328.211H429.609V329.313H423.601ZM439.784 324.186C439.784 325.268 439.588 326.202 439.198 326.99C438.807 327.777 438.272 328.385 437.591 328.812C436.91 329.239 436.132 329.453 435.258 329.453C434.383 329.453 433.606 329.239 432.925 328.812C432.244 328.385 431.708 327.777 431.318 326.99C430.927 326.202 430.732 325.268 430.732 324.186C430.732 323.105 430.927 322.17 431.318 321.383C431.708 320.595 432.244 319.987 432.925 319.56C433.606 319.133 434.383 318.919 435.258 318.919C436.132 318.919 436.91 319.133 437.591 319.56C438.272 319.987 438.807 320.595 439.198 321.383C439.588 322.17 439.784 323.105 439.784 324.186ZM438.582 324.186C438.582 323.298 438.433 322.549 438.136 321.938C437.843 321.327 437.444 320.865 436.94 320.551C436.439 320.238 435.879 320.081 435.258 320.081C434.637 320.081 434.075 320.238 433.571 320.551C433.07 320.865 432.671 321.327 432.374 321.938C432.08 322.549 431.933 323.298 431.933 324.186C431.933 325.074 432.08 325.823 432.374 326.434C432.671 327.045 433.07 327.507 433.571 327.821C434.075 328.135 434.637 328.291 435.258 328.291C435.879 328.291 436.439 328.135 436.94 327.821C437.444 327.507 437.843 327.045 438.136 326.434C438.433 325.823 438.582 325.074 438.582 324.186ZM441.81 329.313H440.508L444.273 319.06H445.555L449.32 329.313H448.018L444.954 320.682H444.874L441.81 329.313ZM442.291 325.308H447.537V326.409H442.291V325.308ZM454.081 329.313H450.917V319.06H454.221C455.216 319.06 456.067 319.265 456.774 319.675C457.482 320.083 458.024 320.668 458.401 321.433C458.778 322.194 458.967 323.105 458.967 324.166C458.967 325.234 458.777 326.154 458.396 326.925C458.016 327.692 457.462 328.283 456.734 328.697C456.007 329.107 455.122 329.313 454.081 329.313ZM452.158 328.211H454.001C454.848 328.211 455.551 328.048 456.108 327.721C456.666 327.394 457.081 326.928 457.355 326.324C457.629 325.72 457.765 325.001 457.765 324.166C457.765 323.338 457.63 322.626 457.36 322.028C457.09 321.428 456.686 320.967 456.148 320.647C455.611 320.323 454.942 320.161 454.141 320.161H452.158V328.211ZM462.291 319.06V329.313H461.05V319.06H462.291ZM472.911 319.06V329.313H471.71L466.122 321.262H466.022V329.313H464.781V319.06H465.982L471.59 327.13H471.69V319.06H472.911ZM482.405 322.264C482.295 321.927 482.149 321.625 481.969 321.357C481.792 321.087 481.58 320.857 481.333 320.667C481.09 320.476 480.813 320.331 480.502 320.231C480.192 320.131 479.851 320.081 479.481 320.081C478.873 320.081 478.321 320.238 477.824 320.551C477.326 320.865 476.931 321.327 476.637 321.938C476.344 322.549 476.197 323.298 476.197 324.186C476.197 325.074 476.345 325.823 476.642 326.434C476.939 327.045 477.342 327.507 477.849 327.821C478.356 328.135 478.927 328.291 479.561 328.291C480.148 328.291 480.666 328.166 481.113 327.916C481.564 327.662 481.914 327.305 482.164 326.845C482.418 326.381 482.545 325.835 482.545 325.207L482.925 325.288H479.841V324.186H483.746V325.288C483.746 326.132 483.566 326.866 483.206 327.49C482.849 328.115 482.355 328.598 481.724 328.942C481.096 329.283 480.375 329.453 479.561 329.453C478.653 329.453 477.856 329.239 477.168 328.812C476.484 328.385 475.95 327.777 475.566 326.99C475.185 326.202 474.995 325.268 474.995 324.186C474.995 323.375 475.104 322.646 475.321 321.998C475.541 321.347 475.851 320.793 476.252 320.336C476.652 319.879 477.126 319.528 477.674 319.285C478.221 319.041 478.823 318.919 479.481 318.919C480.022 318.919 480.526 319.001 480.993 319.165C481.463 319.325 481.882 319.554 482.25 319.851C482.62 320.144 482.929 320.496 483.176 320.907C483.423 321.314 483.593 321.766 483.686 322.264H482.405Z",
    fill: "#363868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.97 351.016H388.923V480.892H402.97V351.016Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.104 350.445H496.058V480.321H510.104V350.445Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.441 441.752H471.185L484.034 408.109H467.29L454.441 441.752Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.994 441.752H431.738L444.587 408.109H427.843L414.994 441.752Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.876 441.752H392.29L405.139 408.109H374.876V441.752Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.737 408.109L493.889 441.752H524.151V408.109H506.737Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.139 408.109L392.291 441.752H414.994L427.843 408.109H405.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.587 408.109L431.738 441.752H454.441L467.29 408.109H444.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.034 408.109L471.185 441.752H493.889L506.737 408.109H484.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.441 395.299H471.185L484.034 361.656H467.29L454.441 395.299Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.994 395.299H431.738L444.587 361.656H427.843L414.994 395.299Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.876 395.299H392.29L405.139 361.656H374.876V395.299Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.737 361.656L493.889 395.299H524.151V361.656H506.737Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.139 361.656L392.29 395.299H414.994L427.842 361.656H405.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.586 361.656L431.737 395.299H454.441L467.29 361.656H444.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.034 361.656L471.185 395.299H493.889L506.737 361.656H484.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.389 431.311H394.639C393.722 431.311 392.978 430.566 392.978 429.649V373.724C392.978 372.807 393.722 372.062 394.639 372.062H504.389C505.306 372.062 506.051 372.807 506.051 373.724V429.649C506.05 430.566 505.306 431.311 504.389 431.311Z",
    fill: "#FFD648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.57 426.291H399.458C398.738 426.291 398.154 425.708 398.154 424.988V377.671C398.154 376.951 398.738 376.367 399.458 376.367H499.57C500.29 376.367 500.873 376.951 500.873 377.671V424.988C500.873 425.708 500.289 426.291 499.57 426.291Z",
    fill: "#FFD648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.288 427.381H405.74C400.957 427.381 397.065 423.491 397.065 418.708V383.955C397.065 379.172 400.957 375.281 405.74 375.281H493.288C498.071 375.281 501.961 379.172 501.961 383.955V418.708C501.961 423.49 498.071 427.381 493.288 427.381ZM405.74 377.458C402.156 377.458 399.242 380.372 399.242 383.955V418.708C399.242 422.29 402.156 425.205 405.74 425.205H493.288C496.87 425.205 499.784 422.291 499.784 418.708V383.955C499.784 380.372 496.87 377.458 493.288 377.458H405.74Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.619 477.068V426.992H569.108V477.068C564.342 477.227 560.712 478.011 560.712 478.96C560.712 480.024 565.257 480.886 570.864 480.886C576.471 480.886 581.015 480.024 581.015 478.96C581.015 478.011 577.385 477.227 572.619 477.068Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.917 429.413L533.135 392.631C532.611 392.108 532.611 391.26 533.135 390.737L569.917 353.955C570.44 353.432 571.288 353.432 571.811 353.955L608.593 390.737C609.116 391.26 609.116 392.108 608.593 392.631L571.811 429.413C571.288 429.937 570.44 429.937 569.917 429.413Z",
    fill: "url(#paint28_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.569 385.34L577.209 362.981C575.513 361.285 573.259 360.352 570.863 360.352C568.465 360.352 566.211 361.285 564.515 362.981L542.157 385.34C540.464 387.032 539.53 389.286 539.53 391.686C539.53 394.085 540.464 396.339 542.155 398.032L564.515 420.392C566.211 422.088 568.465 423.021 570.863 423.021C573.259 423.021 575.513 422.087 577.209 420.392L599.569 398.032C601.265 396.336 602.198 394.082 602.198 391.686C602.198 389.29 601.265 387.036 599.569 385.34ZM597.681 396.146L575.322 418.506C572.945 420.888 568.79 420.891 566.401 418.506H566.403L544.043 396.146C541.583 393.686 541.583 389.685 544.043 387.226L566.401 364.866C568.791 362.481 572.945 362.485 575.322 364.866L597.684 387.226C598.876 388.417 599.532 390.002 599.532 391.686C599.532 393.371 598.875 394.955 597.681 396.146Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.265 398.645C568.348 398.778 568.494 398.891 568.702 398.982C568.911 399.074 569.19 399.145 569.54 399.195C569.89 399.245 570.331 399.27 570.865 399.27C571.382 399.27 571.819 399.244 572.177 399.195C572.536 399.145 572.819 399.074 573.027 398.982C573.236 398.891 573.382 398.778 573.465 398.645C573.548 398.511 573.598 398.362 573.615 398.195L574.265 375.495C574.265 375.279 574.211 375.091 574.102 374.933C573.994 374.775 573.811 374.641 573.552 374.533C573.294 374.424 572.948 374.341 572.515 374.283C572.081 374.224 571.531 374.195 570.865 374.195C570.198 374.195 569.644 374.22 569.202 374.27C568.761 374.32 568.411 374.399 568.152 374.508C567.894 374.616 567.715 374.753 567.615 374.92C567.515 375.087 567.465 375.278 567.465 375.495L568.115 398.195C568.131 398.362 568.181 398.512 568.265 398.645Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.652 402.609C573.377 402.317 573.014 402.109 572.564 401.984C572.114 401.859 571.547 401.797 570.864 401.797C570.181 401.797 569.61 401.859 569.152 401.984C568.693 402.109 568.331 402.317 568.064 402.609C567.797 402.901 567.61 403.284 567.502 403.759C567.393 404.234 567.339 404.821 567.339 405.522C567.339 406.205 567.394 406.78 567.502 407.247C567.61 407.713 567.797 408.088 568.064 408.372C568.331 408.655 568.693 408.859 569.152 408.984C569.61 409.109 570.181 409.172 570.864 409.172C571.547 409.172 572.114 409.109 572.564 408.984C573.014 408.859 573.376 408.655 573.652 408.372C573.927 408.088 574.118 407.713 574.227 407.247C574.335 406.78 574.389 406.205 574.389 405.522C574.389 404.821 574.335 404.234 574.227 403.759C574.118 403.284 573.927 402.901 573.652 402.609Z",
    fill: "#26294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.381 480.889H346.513C348.553 480.889 349.914 478.784 349.076 476.924L347.768 474.023C347.314 473.015 346.311 472.367 345.206 472.367H291.347C290.137 472.367 289.063 473.142 288.68 474.289L287.714 477.191C287.108 479.011 288.462 480.889 290.381 480.889Z",
    fill: "url(#paint29_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.214 419.274C320.928 415.419 316.416 415.419 315.131 419.274L312.462 427.282H324.883L322.214 419.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.217 437.281H309.127L306.614 444.82H330.73L328.217 437.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.28 454.828L300.767 462.366H336.577L334.064 454.828H303.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.883 427.281H312.462L309.127 437.284H328.217L324.883 427.281Z",
    fill: "url(#paint30_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.73 444.828H306.614L303.28 454.831H334.064L330.73 444.828Z",
    fill: "url(#paint31_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.433 472.37H339.912L336.577 462.367H300.767L297.433 472.37Z",
    fill: "url(#paint32_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.303 385.308H427.122V395.258C427.122 396.286 426.88 397.203 426.396 398.01C425.917 398.812 425.239 399.446 424.363 399.91C423.488 400.37 422.461 400.6 421.282 400.6C420.103 400.6 419.075 400.37 418.2 399.91C417.324 399.446 416.644 398.812 416.16 398.01C415.681 397.203 415.441 396.286 415.441 395.258V385.308H417.261V395.112C417.261 395.845 417.422 396.498 417.745 397.071C418.068 397.638 418.528 398.086 419.124 398.413C419.726 398.736 420.445 398.898 421.282 398.898C422.118 398.898 422.837 398.736 423.439 398.413C424.041 398.086 424.5 397.638 424.818 397.071C425.141 396.498 425.303 395.845 425.303 395.112V385.308ZM442.673 385.308V400.336H440.912L432.723 388.537H432.576V400.336H430.756V385.308H432.517L440.736 397.137H440.882V385.308H442.673ZM450.951 400.336H446.314V385.308H451.157C452.615 385.308 453.862 385.609 454.899 386.211C455.936 386.808 456.731 387.666 457.284 388.786C457.837 389.902 458.113 391.237 458.113 392.793C458.113 394.358 457.834 395.706 457.277 396.836C456.719 397.961 455.907 398.827 454.84 399.433C453.774 400.035 452.478 400.336 450.951 400.336ZM448.134 398.722H450.834C452.077 398.722 453.106 398.482 453.923 398.003C454.74 397.523 455.349 396.841 455.75 395.955C456.151 395.07 456.352 394.016 456.352 392.793C456.352 391.58 456.154 390.535 455.758 389.66C455.361 388.779 454.77 388.104 453.982 387.634C453.194 387.16 452.214 386.923 451.04 386.923H448.134V398.722ZM461.166 400.336V385.308H470.235V386.923H462.985V392H469.765V393.615H462.985V398.722H470.352V400.336H461.166ZM473.515 400.336V385.308H478.592C479.767 385.308 480.73 385.509 481.484 385.91C482.237 386.306 482.795 386.852 483.157 387.546C483.519 388.241 483.7 389.031 483.7 389.916C483.7 390.802 483.519 391.587 483.157 392.272C482.795 392.957 482.239 393.495 481.491 393.886C480.742 394.273 479.786 394.466 478.622 394.466H474.513V392.822H478.563C479.365 392.822 480.011 392.705 480.5 392.47C480.994 392.235 481.351 391.903 481.572 391.472C481.797 391.037 481.909 390.518 481.909 389.916C481.909 389.315 481.797 388.789 481.572 388.339C481.347 387.889 480.987 387.541 480.493 387.297C479.999 387.047 479.346 386.923 478.534 386.923H475.335V400.336H473.515ZM480.588 393.585L484.287 400.336H482.173L478.534 393.585H480.588Z",
    fill: "#43457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.816 417.141V409.26H412.324L415.679 414.821H414.88L418.178 409.26H419.675L419.698 417.141H417.987L417.976 411.883H418.291L415.656 416.307H414.835L412.144 411.883H412.527V417.141H410.816ZM425.159 417.141V415.958L425.046 415.7V413.583C425.046 413.208 424.93 412.915 424.697 412.705C424.472 412.495 424.123 412.39 423.65 412.39C423.328 412.39 423.009 412.442 422.693 412.547C422.386 412.645 422.123 412.78 421.905 412.953L421.275 411.726C421.605 411.493 422.003 411.313 422.468 411.185C422.933 411.058 423.406 410.994 423.887 410.994C424.81 410.994 425.526 411.212 426.037 411.647C426.547 412.082 426.802 412.761 426.802 413.684V417.141H425.159ZM423.312 417.231C422.84 417.231 422.434 417.152 422.097 416.994C421.759 416.829 421.5 416.608 421.32 416.33C421.14 416.052 421.05 415.741 421.05 415.396C421.05 415.035 421.136 414.72 421.309 414.45C421.489 414.18 421.77 413.97 422.153 413.82C422.536 413.662 423.035 413.583 423.65 413.583H425.26V414.608H423.842C423.429 414.608 423.144 414.675 422.986 414.81C422.836 414.945 422.761 415.114 422.761 415.317C422.761 415.542 422.847 415.722 423.02 415.857C423.2 415.985 423.444 416.049 423.752 416.049C424.044 416.049 424.307 415.981 424.54 415.846C424.772 415.703 424.941 415.497 425.046 415.227L425.316 416.037C425.189 416.428 424.956 416.724 424.618 416.927C424.281 417.129 423.845 417.231 423.312 417.231ZM428.392 417.141V411.084H430.148V417.141H428.392ZM429.27 410.24C428.947 410.24 428.684 410.146 428.482 409.958C428.279 409.771 428.178 409.538 428.178 409.26C428.178 408.983 428.279 408.75 428.482 408.562C428.684 408.375 428.947 408.281 429.27 408.281C429.593 408.281 429.855 408.371 430.058 408.551C430.261 408.724 430.362 408.949 430.362 409.226C430.362 409.519 430.261 409.763 430.058 409.958C429.863 410.146 429.6 410.24 429.27 410.24ZM435.459 410.994C435.939 410.994 436.367 411.091 436.742 411.287C437.125 411.474 437.425 411.767 437.643 412.165C437.861 412.555 437.969 413.058 437.969 413.673V417.141H436.213V413.943C436.213 413.456 436.104 413.095 435.887 412.863C435.677 412.63 435.377 412.514 434.986 412.514C434.709 412.514 434.457 412.574 434.232 412.694C434.014 412.806 433.842 412.983 433.714 413.223C433.594 413.463 433.534 413.771 433.534 414.146V417.141H431.778V411.084H433.455V412.761L433.14 412.255C433.358 411.849 433.669 411.538 434.074 411.32C434.48 411.103 434.941 410.994 435.459 410.994ZM442.038 417.231C441.325 417.231 440.77 417.05 440.372 416.69C439.974 416.322 439.775 415.778 439.775 415.058V409.744H441.531V415.035C441.531 415.291 441.599 415.489 441.734 415.632C441.869 415.767 442.053 415.835 442.286 415.835C442.563 415.835 442.8 415.76 442.995 415.609L443.468 416.848C443.288 416.975 443.07 417.073 442.815 417.141C442.567 417.201 442.308 417.231 442.038 417.231ZM438.841 412.57V411.219H443.04V412.57H438.841ZM447.272 417.231C446.582 417.231 445.974 417.095 445.449 416.825C444.931 416.555 444.529 416.187 444.244 415.722C443.959 415.249 443.816 414.713 443.816 414.112C443.816 413.504 443.955 412.968 444.233 412.502C444.518 412.03 444.905 411.662 445.392 411.399C445.88 411.129 446.432 410.994 447.047 410.994C447.64 410.994 448.173 411.121 448.646 411.377C449.126 411.624 449.505 411.985 449.783 412.457C450.061 412.923 450.199 413.482 450.199 414.135C450.199 414.202 450.196 414.281 450.188 414.371C450.181 414.454 450.173 414.533 450.166 414.608H445.246V413.583H449.243L448.567 413.887C448.567 413.572 448.503 413.298 448.376 413.065C448.248 412.833 448.072 412.652 447.847 412.525C447.621 412.39 447.359 412.322 447.059 412.322C446.758 412.322 446.492 412.39 446.259 412.525C446.034 412.652 445.858 412.836 445.73 413.077C445.603 413.309 445.539 413.587 445.539 413.91V414.18C445.539 414.51 445.61 414.803 445.753 415.058C445.903 415.306 446.109 415.497 446.372 415.632C446.642 415.76 446.957 415.823 447.317 415.823C447.64 415.823 447.922 415.775 448.162 415.677C448.409 415.579 448.635 415.433 448.837 415.238L449.772 416.251C449.494 416.566 449.145 416.81 448.725 416.983C448.304 417.148 447.82 417.231 447.272 417.231ZM455.05 410.994C455.53 410.994 455.958 411.091 456.333 411.287C456.716 411.474 457.016 411.767 457.234 412.165C457.451 412.555 457.56 413.058 457.56 413.673V417.141H455.804V413.943C455.804 413.456 455.695 413.095 455.478 412.863C455.268 412.63 454.967 412.514 454.577 412.514C454.299 412.514 454.048 412.574 453.823 412.694C453.605 412.806 453.433 412.983 453.305 413.223C453.185 413.463 453.125 413.771 453.125 414.146V417.141H451.369V411.084H453.046V412.761L452.731 412.255C452.948 411.849 453.26 411.538 453.665 411.32C454.07 411.103 454.532 410.994 455.05 410.994ZM462.867 417.141V415.958L462.755 415.7V413.583C462.755 413.208 462.638 412.915 462.406 412.705C462.18 412.495 461.831 412.39 461.359 412.39C461.036 412.39 460.717 412.442 460.402 412.547C460.094 412.645 459.831 412.78 459.614 412.953L458.983 411.726C459.314 411.493 459.711 411.313 460.177 411.185C460.642 411.058 461.115 410.994 461.595 410.994C462.518 410.994 463.235 411.212 463.745 411.647C464.256 412.082 464.511 412.761 464.511 413.684V417.141H462.867ZM461.021 417.231C460.548 417.231 460.143 417.152 459.805 416.994C459.467 416.829 459.208 416.608 459.028 416.33C458.848 416.052 458.758 415.741 458.758 415.396C458.758 415.035 458.844 414.72 459.017 414.45C459.197 414.18 459.479 413.97 459.861 413.82C460.244 413.662 460.743 413.583 461.359 413.583H462.968V414.608H461.55C461.137 414.608 460.852 414.675 460.694 414.81C460.544 414.945 460.469 415.114 460.469 415.317C460.469 415.542 460.556 415.722 460.728 415.857C460.908 415.985 461.152 416.049 461.46 416.049C461.753 416.049 462.015 415.981 462.248 415.846C462.481 415.703 462.65 415.497 462.755 415.227L463.025 416.037C462.897 416.428 462.665 416.724 462.327 416.927C461.989 417.129 461.554 417.231 461.021 417.231ZM469.781 410.994C470.262 410.994 470.69 411.091 471.065 411.287C471.448 411.474 471.748 411.767 471.965 412.165C472.183 412.555 472.292 413.058 472.292 413.673V417.141H470.536V413.943C470.536 413.456 470.427 413.095 470.209 412.863C469.999 412.63 469.699 412.514 469.309 412.514C469.031 412.514 468.78 412.574 468.554 412.694C468.337 412.806 468.164 412.983 468.037 413.223C467.916 413.463 467.856 413.771 467.856 414.146V417.141H466.1V411.084H467.778V412.761L467.462 412.255C467.68 411.849 467.991 411.538 468.397 411.32C468.802 411.103 469.264 410.994 469.781 410.994ZM476.855 417.231C476.202 417.231 475.62 417.099 475.11 416.837C474.599 416.566 474.198 416.195 473.905 415.722C473.62 415.249 473.477 414.713 473.477 414.112C473.477 413.504 473.62 412.968 473.905 412.502C474.198 412.03 474.599 411.662 475.11 411.399C475.62 411.129 476.202 410.994 476.855 410.994C477.493 410.994 478.048 411.129 478.521 411.399C478.994 411.662 479.343 412.041 479.568 412.536L478.206 413.268C478.048 412.983 477.849 412.773 477.609 412.637C477.376 412.502 477.121 412.435 476.843 412.435C476.543 412.435 476.273 412.502 476.033 412.637C475.793 412.773 475.601 412.964 475.459 413.212C475.324 413.459 475.256 413.759 475.256 414.112C475.256 414.465 475.324 414.765 475.459 415.013C475.601 415.26 475.793 415.452 476.033 415.587C476.273 415.722 476.543 415.79 476.843 415.79C477.121 415.79 477.376 415.726 477.609 415.598C477.849 415.463 478.048 415.249 478.206 414.957L479.568 415.7C479.343 416.187 478.994 416.566 478.521 416.837C478.048 417.099 477.493 417.231 476.855 417.231ZM483.508 417.231C482.817 417.231 482.209 417.095 481.684 416.825C481.166 416.555 480.765 416.187 480.479 415.722C480.194 415.249 480.052 414.713 480.052 414.112C480.052 413.504 480.191 412.968 480.468 412.502C480.753 412.03 481.14 411.662 481.628 411.399C482.116 411.129 482.667 410.994 483.283 410.994C483.875 410.994 484.408 411.121 484.881 411.377C485.361 411.624 485.74 411.985 486.018 412.457C486.296 412.923 486.435 413.482 486.435 414.135C486.435 414.202 486.431 414.281 486.423 414.371C486.416 414.454 486.408 414.533 486.401 414.608H481.481V413.583H485.478L484.802 413.887C484.802 413.572 484.739 413.298 484.611 413.065C484.483 412.833 484.307 412.652 484.082 412.525C483.857 412.39 483.594 412.322 483.294 412.322C482.994 412.322 482.727 412.39 482.495 412.525C482.269 412.652 482.093 412.836 481.965 413.077C481.838 413.309 481.774 413.587 481.774 413.91V414.18C481.774 414.51 481.845 414.803 481.988 415.058C482.138 415.306 482.344 415.497 482.607 415.632C482.877 415.76 483.193 415.823 483.553 415.823C483.875 415.823 484.157 415.775 484.397 415.677C484.645 415.579 484.87 415.433 485.073 415.238L486.007 416.251C485.729 416.566 485.38 416.81 484.96 416.983C484.54 417.148 484.056 417.231 483.508 417.231Z",
    fill: "#43457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.845 341.424C617.845 341.424 601.914 335.009 593.587 324.22C585.26 313.431 579.105 269.984 579.105 269.984L617.845 255.987L617.853 255.99V252.698L617.845 252.695L576.12 267.77C576.12 267.77 582.749 314.566 591.718 326.186C600.687 337.807 617.845 344.716 617.845 344.716C617.845 344.716 617.852 344.713 617.853 344.713V341.42C617.852 341.421 617.845 341.424 617.845 341.424Z",
    fill: "#4F36E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.105 269.981C579.105 269.981 585.26 313.428 593.587 324.218C601.915 335.007 617.845 341.421 617.845 341.421C617.845 341.421 617.852 341.418 617.853 341.418V255.987L617.845 255.984L579.105 269.981Z",
    fill: "#5854D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.972 326.183C652.941 314.563 659.57 267.767 659.57 267.767L617.853 252.695V255.987L656.584 269.981C656.584 269.981 650.43 313.428 642.102 324.217C633.82 334.949 618.022 341.35 617.853 341.418V344.71C618.022 344.642 635.047 337.746 643.972 326.183Z",
    fill: "url(#paint33_linear_2850_2613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.102 324.222C650.43 313.433 656.584 269.986 656.584 269.986L617.853 255.992V341.423C618.022 341.355 633.82 334.953 642.102 324.222Z",
    fill: "#6F62ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.845 262.055L584.606 274.064C584.606 274.064 589.887 311.341 597.032 320.597C604.176 329.854 617.845 335.358 617.845 335.358C617.845 335.358 631.512 329.854 638.657 320.597C645.802 311.341 651.083 274.064 651.083 274.064L617.845 262.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.77 287.876H629.712V286.272C629.712 279.729 624.389 274.406 617.845 274.406C611.301 274.406 605.978 279.729 605.978 286.272V287.876H605.92C604.216 287.876 602.834 289.258 602.834 290.962V311.124C602.834 312.828 604.216 314.21 605.92 314.21H617.845H629.771C631.475 314.21 632.856 312.828 632.856 311.124V290.962C632.856 289.258 631.474 287.876 629.77 287.876ZM619.939 299.148V308.442H617.845H615.751V299.148C614.258 298.264 613.356 296.487 613.847 294.536C614.2 293.133 615.338 291.978 616.739 291.615C617.114 291.517 617.485 291.472 617.845 291.473C618.205 291.473 618.575 291.517 618.951 291.615C620.352 291.978 621.49 293.133 621.843 294.536C622.334 296.488 621.432 298.264 619.939 299.148ZM624.77 287.876H617.845H610.919V286.272C610.919 282.455 614.025 279.348 617.845 279.348C621.665 279.348 624.77 282.455 624.77 286.272V287.876Z",
    fill: "url(#paint34_linear_2850_2613)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_2613",
    x1: 179.635,
    y1: 441.551,
    x2: 137.111,
    y2: 441.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2850_2613",
    x1: 146.574,
    y1: 419.842,
    x2: 105.088,
    y2: 425.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#A80C5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2850_2613",
    x1: 128.306,
    y1: 452.74,
    x2: 145.488,
    y2: 469.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2850_2613",
    x1: 119.86,
    y1: 448.579,
    x2: 71.3976,
    y2: 448.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2850_2613",
    x1: 279.688,
    y1: 318.916,
    x2: 619.34,
    y2: 318.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#F1F9FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2850_2613",
    x1: 260.76,
    y1: 485.337,
    x2: 265.45,
    y2: 470.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40447B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2850_2613",
    x1: 165.245,
    y1: 386.133,
    x2: 179.601,
    y2: 392.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40447B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2850_2613",
    x1: 222.873,
    y1: 439.028,
    x2: 246.014,
    y2: 358.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40447B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2850_2613",
    x1: 217.479,
    y1: 317.44,
    x2: 324.714,
    y2: 317.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB33CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#F9C9E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2850_2613",
    x1: 116.822,
    y1: 156.589,
    x2: 410.157,
    y2: 215.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#FFE6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2850_2613",
    x1: 448.227,
    y1: 120.654,
    x2: 161.461,
    y2: 71.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F556D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#C32A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2850_2613",
    x1: 148.46,
    y1: 64.3618,
    x2: 157.935,
    y2: 66.2525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2ED94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69C7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2850_2613",
    x1: 165.494,
    y1: 67.7614,
    x2: 174.969,
    y2: 69.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00050512,
    stopColor: "#FEBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9841,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2850_2613",
    x1: 182.528,
    y1: 71.159,
    x2: 192.002,
    y2: 73.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3393EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#37BEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2850_2613",
    x1: 446.72,
    y1: 298.71,
    x2: 452.307,
    y2: 298.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2850_2613",
    x1: 446.72,
    y1: 237.655,
    x2: 452.307,
    y2: 237.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3393EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#37BEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2850_2613",
    x1: 412.403,
    y1: 268.184,
    x2: 425.571,
    y2: 268.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2850_2613",
    x1: 473.456,
    y1: 268.184,
    x2: 486.624,
    y2: 268.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2850_2613",
    x1: 429.159,
    y1: 294.543,
    x2: 439.068,
    y2: 294.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2850_2613",
    x1: 459.959,
    y1: 241.824,
    x2: 469.869,
    y2: 241.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3393EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#37BEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2850_2613",
    x1: 416.841,
    y1: 252.783,
    x2: 429.472,
    y2: 252.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2850_2613",
    x1: 469.556,
    y1: 283.58,
    x2: 482.187,
    y2: 283.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2850_2613",
    x1: 416.926,
    y1: 283.715,
    x2: 429.54,
    y2: 283.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2850_2613",
    x1: 469.487,
    y1: 252.652,
    x2: 482.102,
    y2: 252.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3393EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#37BEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2850_2613",
    x1: 429.011,
    y1: 241.901,
    x2: 438.955,
    y2: 241.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2850_2613",
    x1: 460.072,
    y1: 294.464,
    x2: 470.016,
    y2: 294.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2850_2613",
    x1: 403.903,
    y1: 339.729,
    x2: 462.502,
    y2: 339.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3393EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#37BEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2850_2613",
    x1: 402.632,
    y1: 339.694,
    x2: 496.395,
    y2: 339.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#292E6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2850_2613",
    x1: 532.742,
    y1: 391.684,
    x2: 608.985,
    y2: 391.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00050512,
    stopColor: "#FEBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9841,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2850_2613",
    x1: 287.568,
    y1: 476.628,
    x2: 349.327,
    y2: 476.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2850_2613",
    x1: 309.127,
    y1: 432.283,
    x2: 328.217,
    y2: 432.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2850_2613",
    x1: 303.28,
    y1: 449.829,
    x2: 334.064,
    y2: 449.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2850_2613",
    x1: 297.433,
    y1: 467.369,
    x2: 339.912,
    y2: 467.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2850_2613",
    x1: 617.853,
    y1: 298.703,
    x2: 659.57,
    y2: 298.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#AC81F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6466D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2850_2613",
    x1: 602.834,
    y1: 294.308,
    x2: 632.856,
    y2: 294.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2ED94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69C7B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2850_2613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 687,
    height: 500.758,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/Banner.e39eba6173643288b8b5f08817bac6fd.svg";
export { ForwardRef as ReactComponent };